<template>
  <div class="data-solution">


    <!-- 内容区域 -->
    <div class="solution-container">
      <div class="solution-content" ref="contentSection" :class="{ 'fade-in': isContentVisible }">
        <!-- 背景介绍 -->
        <div class="background-section">
          <!-- <h3>背景介绍</h3> -->
          <p>湖南美音网络技术有限公司具备多年政府项目实施、运维经验，熟悉政府部门工作流程与工作要求；具备大型项目管理能力，实施交付与运维能力突出；熟悉政务云建设体系框架，熟悉政务数据管理体系标准，熟悉数据治理项目实施与运维要求；</p>
          <p>&nbsp;</p>
          <p>MeinnDM数据治理系统是基于AI和大数据技术的企业级智能平台，致力于帮助客户构建"数据采集—清洗—存储—应用"的全链路治理体系。通过自动化工具、智能分析和可视化决策支持，系统实现数据资产的高效管理、质量提升与合规保障，助力企业释放数据价值，驱动业务创新。</p>
        </div>

        <!-- 数据平台 -->
        <div class="platform-section">
          <h3>一站式湖仓一体数据智能平台（MeinnDM）</h3>
          <div class="platform-architecture">
            <div class="architecture-layer" v-for="(layer, index) in platformLayers" :key="index">
              <div class="layer-title">{{ layer.title }}</div>
              <div class="layer-content">
                <div class="module" v-for="(module, mIndex) in layer.modules" :key="mIndex">
                  {{ module }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 服务能力 -->
        <div class="capabilities-section">
          <h3>服务能力</h3>
          <div class="capabilities-grid">
            <div class="capability-card" v-for="(capability, index) in capabilities" :key="index">
              <div class="capability-icon">
                <el-icon><component :is="capability.icon" /></el-icon>
              </div>
              <div class="capability-content">
                <h4>{{ capability.title }}</h4>
                <p>{{ capability.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据指标 -->
        <div class="metrics-section">
          <h3>数据治理成效</h3>
          <div class="metrics-grid">
            <div class="metric-card" v-for="(metric, index) in metrics" :key="index">
              <div class="metric-value">{{ metric.value }}</div>
              <div class="metric-label">{{ metric.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { DataAnalysis, DataLine, Connection, Histogram, Management, Setting } from '@element-plus/icons-vue'

const platformLayers = [
  {
    title: '应用层',
    modules: ['数据可视化', '数据分析', '数据服务', '数据应用']
  },
  {
    title: '平台层',
    modules: ['数据集成', '数据处理', '数据存储', '数据管理', '数据安全']
  },
  {
    title: '基础层',
    modules: ['基础设施', '计算资源', '存储资源', '网络资源']
  }
]

const capabilities = [
  {
    title: '数据标准化',
    description: '建立统一的数据标准体系，实现数据的规范化管理和高效利用',
    icon: 'Management'
  },
  {
    title: '数据质量管理',
    description: '通过数据清洗、校验等手段，确保数据的准确性、完整性和一致性',
    icon: 'DataLine'
  },
  {
    title: '数据安全管理',
    description: '建立完善的数据安全保护机制，确保数据的安全性和可控性',
    icon: 'Setting'
  },
  {
    title: '数据共享服务',
    description: '提供便捷的数据共享和交换服务，促进数据资源的有效流通',
    icon: 'Connection'
  },
  {
    title: '数据分析挖掘',
    description: '运用先进的数据分析技术，挖掘数据价值，支持决策',
    icon: 'DataAnalysis'
  },
  {
    title: '数据可视化',
    description: '通过直观的图表展示数据，提升数据理解和使用效率',
    icon: 'Histogram'
  }
]

const metrics = [
  { value: '提升数据准确率', label: '' },
  { value: '提高数据利用率', label: '' },
  { value: '提升决策效率', label: '' },
  { value: '优化业务流程', label: '' }
]

const isHeaderVisible = ref(false)
const isContentVisible = ref(false)
const headerSection = ref(null)
const contentSection = ref(null)

onMounted(() => {
  // 确保页面从顶部开始显示
  console.log('📊 数据治理解决方案组件挂载，确保滚动到顶部')
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === headerSection.value) {
        isHeaderVisible.value = entry.isIntersecting
      }
      if (entry.target === contentSection.value) {
        isContentVisible.value = entry.isIntersecting
      }
    })
  }, { threshold: 0.2 })

  if (headerSection.value) observer.observe(headerSection.value)
  if (contentSection.value) observer.observe(contentSection.value)

  return () => observer.disconnect()
})
</script>

<style lang="scss" scoped>
.data-solution {
  padding: 40px 0;

  .solution-header {
    text-align: center;
    margin-bottom: 60px;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }

    .title-box {
      h1 {
        font-size: 36px;
        color: #333;
        margin-bottom: 16px;
      }

      p {
        font-size: 18px;
        color: #666;
      }
    }
  }

  .solution-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .solution-content {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .background-section {
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    margin-bottom: 40px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 20px;
      text-align: center;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 1.8;
    }
  }

  .platform-section {
    margin-bottom: 40px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .platform-architecture {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .architecture-layer {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);

        .layer-title {
          background: #2b5dff;
          color: #fff;
          padding: 15px 20px;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
        }

        .layer-content {
          display: flex;
          flex-wrap: wrap;
          padding: 20px;
          gap: 15px;
          justify-content: center;

          .module {
            background: rgba(43,93,255,0.1);
            color: #2b5dff;
            padding: 10px 20px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.3s;
            text-align: center;

            &:hover {
              background: rgba(43,93,255,0.2);
              transform: translateY(-3px);
            }
          }
        }
      }
    }
  }

  .capabilities-section {
    margin-bottom: 40px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .capabilities-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 30px;

      .capability-card {
        background: #fff;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        display: flex;
        align-items: flex-start;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }

        .capability-icon {
          width: 50px;
          height: 50px;
          background: rgba(43,93,255,0.1);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          color: #2b5dff;
          font-size: 24px;
          flex-shrink: 0;
        }

        .capability-content {
          flex: 1;

          h4 {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
          }
        }
      }
    }
  }

  .metrics-section {
    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .metrics-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 30px;

      .metric-card {
        background: #fff;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        text-align: center;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          background: #2b5dff;

          .metric-value {
            color: #fff;
          }
        }

        .metric-value {
          font-size: 18px;
          font-weight: bold;
          color: #2b5dff;
          margin-bottom: 0;
          transition: all 0.3s;
        }

        .metric-label {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .data-solution {
    padding: 20px 0;

    .capabilities-grid, .metrics-grid {
      grid-template-columns: 1fr !important;
    }
  }
}
</style> 
